'use strict';

class Slider {

    constructor() {
        this.element = '.owl-carousel';
        this.navPrev = '.personalizator__slider-prev';
        this.navNext = '.personalizator__slider-next';

        $(document).ready(() => {
            this.bindOwl();
            this.bindNavs();     
        });
    }

    bindOwl() {
        if ($(this.element).length) {
            this.owl = $(this.element).owlCarousel({
                loop: false,
                margin: 10,
                items: 6
            });
        }
    }

    bindNavs() {

        $(this.navPrev).click(() => {
            this.owl.trigger('prev.owl.carousel');
            return false;
        });

        $(this.navNext).click(() => {
            this.owl.trigger('next.owl.carousel');
            return false;
        });

    }

}

export const slider = new Slider();
